module.exports = __webpack_public_path__ + "img/28_17.f7e69ec8.png";